export default __webpack_public_path__ + "68a3d6d47bf694b56c2e819bd2c1cf95.svg";